import React, { ReactElement } from 'react';
import { useSelector } from '@xstate/react';
import { NotificationActor } from 'xstate/actors/NotificationActor';
import Notification from 'elements/Notification/Notification';

const Notifications = (): ReactElement => {
  const state = useSelector(NotificationActor, (snapshot) => snapshot);

  return (
    <div className={styles.container}>
      <div className={styles.notificationList}>
        {state.context.notifications.map((notification) => (
          <Notification key={notification.id} notification={notification} />
        ))}
      </div>
    </div>
  );
};

export default Notifications;

const styles = {
  container:
    'fixed inset-0 z-30 flex items-start px-4 py-4 pointer-events-none sm:px-6 sm:py-20',
  notificationList: 'w-full flex flex-col items-end space-y-4',
};
